import storeManager from '../../store/StoreManager';
import interactionVisibilityActions from '../../actions/InteractionVisibilityActions';
import sessionReader from '../../store/readHelpers/SessionReader';

const ALWAYS = 'always';
const WHEN_COMPLETED = 'whenCompleted';
const WHEN_COMPLETED_AUTOPLAY = 'whenCompletedAutoplay';

const interactionVisibilityService = {
    visibilityValues: {
        ALWAYS,
        WHEN_COMPLETED,
        WHEN_COMPLETED_AUTOPLAY,
    },
    getMediaModelTriggeringInteractionHide(mediaModels) {
        if (!(Array.isArray(mediaModels) && mediaModels.length > 0)) {
            return undefined;
        }
        return mediaModels.find((mediaModel) => {
            return [WHEN_COMPLETED, WHEN_COMPLETED_AUTOPLAY].includes(mediaModel.interactionVisibility);
        });
    },
    setInteractionVisibilityIfAvailable(questionId, mediaModels) {
        const mediaModel = this.getMediaModelTriggeringInteractionHide(mediaModels);
        const state = storeManager.getState();
        if (mediaModel && !state.interactionVisibility[questionId]) {
            storeManager.dispatch(
                interactionVisibilityActions.hideInteractionsInQuestion(
                    questionId,
                    mediaModel.logicalName,
                    mediaModel.interactionVisibility,
                )
            );
        }
    },
    showInteractionsInQuestion(questionId, mediaLogicalName) {
        const state = storeManager.getState();
        const interactionVisibilityObject = state.interactionVisibility[questionId];
        if (
            typeof interactionVisibilityObject === 'object' &&
            interactionVisibilityObject.mediaLogicalName === mediaLogicalName
        ) {
            storeManager.dispatch(
                interactionVisibilityActions.showInteractionsInQuestion(questionId)
            );
            if (!interactionVisibilityObject.autoPlayAudio) {
                this.setVisibilityTransactionDoneForQuestion(questionId);
            }
        }
    },
    setVisibilityTransactionDoneForQuestion(questionId) {
        storeManager.dispatch(
            interactionVisibilityActions.setVisibilityTransactionDoneForQuestion(questionId)
        );
    },
    shouldShowInteractions(questionInteractionVisibility, viewMedia) {
        if (!sessionReader.isViewMediaScreen(viewMedia) || typeof questionInteractionVisibility !== 'object') {
            return true;
        }
        return questionInteractionVisibility.showInteractions !== false;
    },

    shouldTriggerAutoPlay(interactionIdentifier, question, viewMedia) {
        const state = storeManager.getState();
        const questionInteractionVisibility = state.interactionVisibility[question.contentRevisionId];

        if (!sessionReader.isViewMediaScreen(viewMedia) || typeof questionInteractionVisibility !== 'object') {
            return false;
        }

        if (question.responseModels[0].identifier !== interactionIdentifier) {
            return false; // We auto play only the first interaction in a question.
        }

        return questionInteractionVisibility.showInteractions
            && questionInteractionVisibility.autoPlayAudio
            && !questionInteractionVisibility.transactionDone;
    },
};

export default interactionVisibilityService;
